.component {
  margin: 23px var(--margin) 20px 20px;
  overflow: auto;
}

.title {
  font-size: 26px;
  font-weight: 300;
  color: var(--tealish);
}

.subTitle {
  margin: 12px 0 20px 0;
  font-size: 16px;
  font-weight: 300;
  color: var(--black);
  max-width: 640px;
}

.list {
  display: flex;
  flex-direction: column;
}

.webhookItem {
  margin: 3px 3px 3px 0;
  padding: 12px 16px;
  width: 640px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
}

.webhookItem:nth-child(even) {
  background-color: var(--fully-white);
}

.webhookItem:nth-child(odd) {
  background-color: var(--light-grey);
}

.itemRow {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.url {
  flex-grow: 1;
  font-size: 16px;
  font-weight: 300;
  color: var(--marine);
  word-break: break-all;
  margin-right: 12px;
}

.testChoices {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;
}

.choiceButton {
  color: var(--marine);
  background-color: var(--fully-white);
  border: solid 1px var(--marine);
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}

.trash {
  cursor: pointer;
  width: 18px;
}

.send {
  cursor: pointer;
  width: 18px;
  margin: 0 14px;
}

.pen {
  cursor: pointer;
  width: 16px;
  margin: 0 14px;
}

.apps {
  display: flex;
  align-items: center;
  margin: 0 16px;
  font-size: 14px;
  font-weight: 300;
  color: var(--black);
  overflow: hidden;
}

.appsLabel {
  margin-right: 8px;
  color: var(--brown-grey);
  white-space: nowrap;
}

.appsNames {
  color: var(--marine);
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appsHint {
  color: var(--brown-grey);
  font-style: italic;
}

.editForm {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.appsRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.appSelect {
  flex-grow: 1;
  font-size: 14px;
  font-weight: 300;
}

.editButtons {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.saveButton {
  color: var(--marine);
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
}

.cancelButton {
  color: var(--brown-grey);
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
}

.underline {
  margin: 20px 0;
  width: 640px;
  border-bottom: solid 1px var(--very-light-pink);
}

.addPanel {
  margin: 10px 3px 20px 0;
  width: 640px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background-color: var(--light-grey);
  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.25);
  border-radius: 4px;
}

.addRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.input {
  flex-grow: 1;
  min-width: 0;
  height: 29px;
  border: 0;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 300;
  padding: 0 10px;
  color: var(--marine);
  background-color: var(--fully-white);
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.22);
  outline-style: none;
}

.addButton {
  color: var(--marine);
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}

.headers {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.headersLabel {
  font-size: 14px;
  font-weight: 300;
  color: var(--brown-grey);
}

.headerRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.headerRemove {
  border: none;
  background: none;
  color: var(--brown-grey);
  font-size: 14px;
  cursor: pointer;
  padding: 0 4px;
}

.addHeaderButton {
  align-self: flex-start;
  color: var(--marine);
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  padding: 0;
}

.regenButton {
  align-self: flex-start;
  color: var(--marine);
  background-color: var(--fully-white);
  border: solid 1px var(--marine);
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}

.secretPopup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.secretNote {
  font-size: 14px;
  font-weight: 300;
  color: var(--black);
  max-width: 360px;
}

.secretText {
  width: 360px;
  height: 60px;
  resize: none;
  font-family: monospace;
  font-size: 13px;
  padding: 8px;
  border: solid 1px var(--pinkish-grey);
  border-radius: 4px;
  color: var(--marine);
}
